/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboGetsentineloneapplicationsApplicationResult
 */
export interface JumboGetsentineloneapplicationsApplicationResult {
    /**
     * 
     * @type {number}
     * @memberof JumboGetsentineloneapplicationsApplicationResult
     */
    agentCount?: number;
    /**
     * 
     * @type {string}
     * @memberof JumboGetsentineloneapplicationsApplicationResult
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboGetsentineloneapplicationsApplicationResult
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboGetsentineloneapplicationsApplicationResult
     */
    publisher?: string;
    /**
     * 
     * @type {number}
     * @memberof JumboGetsentineloneapplicationsApplicationResult
     */
    versionCount?: number;
}

/**
 * Check if a given object implements the JumboGetsentineloneapplicationsApplicationResult interface.
 */
export function instanceOfJumboGetsentineloneapplicationsApplicationResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboGetsentineloneapplicationsApplicationResultFromJSON(json: any): JumboGetsentineloneapplicationsApplicationResult {
    return JumboGetsentineloneapplicationsApplicationResultFromJSONTyped(json, false);
}

export function JumboGetsentineloneapplicationsApplicationResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboGetsentineloneapplicationsApplicationResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'agentCount': !exists(json, 'agentCount') ? undefined : json['agentCount'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'publisher': !exists(json, 'publisher') ? undefined : json['publisher'],
        'versionCount': !exists(json, 'versionCount') ? undefined : json['versionCount'],
    };
}

export function JumboGetsentineloneapplicationsApplicationResultToJSON(value?: JumboGetsentineloneapplicationsApplicationResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'agentCount': value.agentCount,
        'id': value.id,
        'name': value.name,
        'publisher': value.publisher,
        'versionCount': value.versionCount,
    };
}

